import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57de5ab2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "snackbar-container" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  class: "snackbar-type-icon"
}
const _hoisted_4 = { class: "snackbar-text f-13 f-sm-16" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "snackbar",
      class: _normalizeClass(["snackbar snackbar-active", _ctx.type]),
      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSnackbarClick && _ctx.handleSnackbarClick(...args)), ["stop"]))
    }, [
      (_ctx.icon)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: `${_ctx.cdn}/${_ctx.icon.src}`,
            alt: `${_ctx.icon.alt}`,
            width: "20",
            height: "20"
          }, null, 8 /* PROPS */, _hoisted_2))
        : _createCommentVNode("v-if", true),
      (_ctx.type)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              innerHTML: _ctx.title
            }, null, 8 /* PROPS */, _hoisted_5))
          : _createCommentVNode("v-if", true),
        (_ctx.body)
          ? (_openBlock(), _createElementBlock("p", {
              key: 1,
              innerHTML: _ctx.body
            }, null, 8 /* PROPS */, _hoisted_6))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("span", {
        class: "snackbar-close-icon",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSnackbarClose && _ctx.handleSnackbarClose(...args)), ["stop"]))
      })
    ], 2 /* CLASS */)
  ]))
}